<template>
    <div>
        <a-card title="登录" style="width: 400px;margin:200px auto;" bordered :loading="loading" v-if="show">
            <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                <a-form-item label="账号">
                    <a-input v-model="form.username"></a-input>
                </a-form-item>
                <a-form-item label="密码">
                    <a-input v-model="form.password" type="password"></a-input>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
                    <a-button type="primary" html-type="submit" @click="handleSubmit">确定</a-button>
                </a-form-item>
            </a-form>
        </a-card>
    </div>
</template>
<script>
import Vue from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

export default {
    data() {
        return {
            form: {
                username: '',
                password: ''
            },
            loading: false,
            show: false,
        }
    },
    methods: {
        handleSubmit() {
            let pre = "";
            switch (window.location.host) {
                case "localhost:8080": pre = ""; break;
                case "aivideo2.video-force.cn": pre = "vftest_"; break;
                case "aivideo2.yishitui.cn": pre = "ysttest_"; break;
                case "aivideo.video-force.cn": pre = "vf_"; break;
                case "aivideo.yishitui.cn": pre = "yst_"; break;
                case "aivideo.zxp168.com": pre = "wcw_"; break;
                case "admin.aivideo2.yishitui.cn": break;
                case "admin.aivideo.yishitui.cn": break;
            };

            this.loading = true;
            this.$post('/user/login', { username: pre + this.form.username, password: this.form.password, from_plat: 4 })
                .then(res => {
                    if (res.code == 200) {
                        this.$message.success('正在登录');
                        location.href = '/login?token=' + res.data.token;
                    } else {
                        this.$message.error(res.msg);
                    }
                    this.loading = false;
                }).catch(a => {
                    this.$message.error(a);
                })
        }
    },
    created() {
        var query = this.$route.query;
        var token = query.token;
        if (token) {
            this.show = false;
            localStorage.setItem("ai-token", token)
            this.$get('/user/detail').then(res => {
                if (res.code == 200) {
                    this.$message.success('验证通过');
                    localStorage.setItem("ai-info", JSON.stringify(res.data))
                    if (res.data.auth == 'administrator') {
                         location.href = '/admin';
                    }
                    else {
                        // location.href = '/';
                        this.$router.push('home')
                    }

                }
            })
        } else {
            this.show = true;
        }
    }
}
</script>